import { ENV_CONFIG } from 'env-config';
import { PaginationState } from 'types/custom/common';
import { SimulationSource } from 'types/custom/simulation';
const serverURL = ENV_CONFIG.albServerUrl;
const backtestingURL = ENV_CONFIG.backtestingURL;
const liveTickServerUrl = ENV_CONFIG.liveTickServerUrl;

class API {
  // GET Websocket API

  getCountry() {
    return localStorage.getItem('country');
  }

  getWebSocketAPI() {
    return ENV_CONFIG.websocketServerUrl;
  }

  //* AUTH API'S
  login(): string {
    return `${serverURL}/user/${this.getCountry()}/v1/admin/exists`;
  }

  forgotPassword(): string {
    return `${serverURL}/user/${this.getCountry()}/v1/password/forgot`;
  }

  verifyOtp(): string {
    return `${serverURL}/user/${this.getCountry()}/v1/password/verify-otp`;
  }

  resetPassword(): string {
    return `${serverURL}/user/${this.getCountry()}/v1/password/reset`;
  }

  changePassword(): string {
    return `${serverURL}/user/${this.getCountry()}/v1/password/change`;
  }

  register(): string {
    return `${serverURL}/user/${this.getCountry()}/v1/create`;
  }

  //* ADMIN API'S
  saveAdmin(): string {
    return `${serverURL}/user/${this.getCountry()}/v1/employee/create`;
  }

  //* STOCK API'S

  getAllAvailableStocks() {
    return `${serverURL}/stock/${this.getCountry()}/v1/list`;
  }

  saveStock() {
    return `${serverURL}/stock/${this.getCountry()}/v1/save`;
  }

  fetchHistoricPrices() {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/fetch`;
  }

  deleteHistoricPrice(stockId: string) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/delete?stockId=${stockId}`;
  }

  importStock(stockName: string): string {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/import?stockName=${stockName}`;
  }

  getTimePeriodsOfRunningStrategy(stockId: string): string {
    return `${serverURL}/v1/trade/stock/${this.getCountry()}/period?stockId=${stockId}`;
  }

  getOhlcAndIndicatorByTimePeriod(stockId: string, timePeriod: string): string {
    return `${serverURL}/v1/trade/stock/${this.getCountry()}/candles?stockId=${stockId}&stockPeriod=${timePeriod}`;
  }

  getAllStockGroups() {
    return `${serverURL}/stock/${this.getCountry()}/v1/stock-group/all`;
  }

  saveStockGroup() {
    return `${serverURL}/stock/${this.getCountry()}/v1/stock-group/save`;
  }

  updateStockGroup(groupId: string) {
    return `${serverURL}/stock/${this.getCountry()}/v1/stock-group/update?groupId=${groupId}`;
  }

  deleteStockGroup(groupId: string) {
    return `${serverURL}/stock/${this.getCountry()}/v1/stock-group/delete?groupId=${groupId}`;
  }

  //* HEALTH CHECK API'S

  checkServerHealth(): string {
    return `${serverURL}/server-health/${this.getCountry()}/v1/check-health`;
  }

  //* SIMULATION

  startSimulation() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/start`;
  }

  startBackTesting() {
    return `${backtestingURL}/back-testing/${this.getCountry()}/v1/start`;
  }
  startMultiSimulation() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/start/multi`;
  }

  updateSimulationConfig() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/config/update`;
  }

  stopMultiSimulation(simulationId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/stop/multi?simulationId=${simulationId}`;
  }

  hideSimulation(simulationId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/hide?simulationId=${simulationId}`;
  }

  executeInMarket(simulationId: string, executeInMarket: boolean) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/execute-in-market?simulationId=${simulationId}&executeInMarket=${executeInMarket}`;
  }

  addUserToLiveTrade(simulationId: string, userId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/add-user?simulationId=${simulationId}&userId=${userId}`;
  }
  removeUserFromLiveTrade(simulationId: string, userId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/remove-user?simulationId=${simulationId}&userId=${userId}`;
  }

  restartMultiSimulation(simulationId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/restart/multi?simulationId=${simulationId}`;
  }

  forceRestartSimulations() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/forceRestart`;
  }

  getSimulationHistory({ page, limit }: PaginationState) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/all?page=${page}&limit=${limit}`;
  }

  getLiveSimulationHIstory({ page, limit }: PaginationState) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/live?page=${page}&limit=${limit}`;
  }

  getRecommendationSimulationHistory({ page, limit }: PaginationState) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/recommendations?page=${page}&limit=${limit}`;
  }

  getSimulationById(simulationId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/get?simulationId=${simulationId}`;
  }

  getNoTradeLog(simulationId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/get/no-trade-decision?simulationId=${simulationId}`;
  }

  getSimulationByIdV2(simulationId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v2/get?simulationId=${simulationId}`;
  }

  getAccountsById(userIds: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/list?accountIds=${userIds}`;
  }

  getOrdersBySimulation(stockId: string): string {
    return `${serverURL}/simulation/${this.getCountry()}/v1/orders/active?stockId=${stockId}`;
  }

  // getTransactionsBySimulation(stockId: string): string {
  //   return `${serverURL}/v1/simulation/transactions/active?stockId=${stockId}`;
  // }

  getTradeForSimulation(stockId: string): string {
    return `${serverURL}/simulation/${this.getCountry()}/v1/trade/active?stockId=${stockId}`;
  }

  getTransactionsForChart(simulationId: string): string {
    return `${serverURL}/simulation/${this.getCountry()}/v1/transactions?simulationId=${simulationId}`;
  }

  getStockById(stockId: string): string {
    return `${serverURL}/stock/${this.getCountry()}/v1/get?stockId=${stockId}`;
  }

  // getDailyTransactionByStockId(stockId: string): string {
  //   return `${serverURL}/v1/simulation/transactions/daily?stockId=${stockId}`;

  // }

  setDelay(stockId: string, delay: number): string {
    return `${serverURL}/simulation/${this.getCountry()}/delay?stockId=${stockId}&delay=${delay}`;
  }

  getAllStrategies() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/strategies`;
  }

  //* USER API'S

  refreshUser(userId: string) {
    return `${serverURL}/user-context/${this.getCountry()}/v1/portfolio/refresh?userId=${userId}`;
  }

  getAllUsers() {
    return `${serverURL}/user/${this.getCountry()}/v1/list`;
  }

  getAllDecisionUsers() {
    return `${serverURL}/decision-log/${this.getCountry()}/v1/user-list`
  }

  getAllDecisionStrategies() {
    return `${serverURL}/decision-log/${this.getCountry()}/v1/strategies`
  }

  getAllSubscriptions(page: number, limit: number) {
    return `${serverURL}/subscription/${this.getCountry()}/v1/list?page=${page}&limit=${limit}`
  }

  getAllRecommendationStrategies() {
    return `${serverURL}/recommendation-decision-log/${this.getCountry()}/v1/strategies`
  }

  getAllRecommendationUsers() {
    return `${serverURL}/recommendation-decision-log/${this.getCountry()}/v1/user-list`
  }

  getAllCompleteUsers() {
    return `${serverURL}/user/${this.getCountry()}/v1/list/complete`
  }

  getAllInCompleteUsers() {
    return `${serverURL}/user/${this.getCountry()}/v1/list/incomplete`
  }

  getAllUsersLite() {
    return `${serverURL}/user/${this.getCountry()}/v1/list/lite`;
  }

  getAllIciciUsers() {
    return `${serverURL}/user/${this.getCountry()}/v1/icici/list`;
  }

  getAllEmployee() {
    return `${serverURL}/user/${this.getCountry()}/v1/employee/list`;
  }

  getPortFolio(userId: string) {
    return `${serverURL}/user-context/${this.getCountry()}/portfolio?userId=${userId}`;
  }

  getLoginUrlFromZerodha(userId: string) {
    return `${serverURL}/user-context/${this.getCountry()}/url?userId=${userId}`;
  }

  connectToZerodha() {
    return `${serverURL}/livetick/${this.getCountry()}/v1/session/url`;
  }

  submitTokenFromZerodha() {
    return `${serverURL}/user-context/${this.getCountry()}/create`;
  }

  getVerificationCode() {
    return `${serverURL}/user/${this.getCountry()}/v1/connect`;
  }

  verifyCode() {
    return `${serverURL}/user/${this.getCountry()}/v1/verify`;
  }

  saveUser() {
    return `${serverURL}/user/${this.getCountry()}/v1/admin/save`;
  }

  updateUser(userId: string) {
    return `${serverURL}/user/${this.getCountry()}/v1/update/${userId}`;
  }

  blockAndUnblockUser() {
    return `${serverURL}/${this.getCountry()}/v1/user/active`;
  }
  blockAndUnblockTradingAccount(userId: string, enabled: boolean) {
    return `${serverURL}/user-context/${this.getCountry()}/v1/admin/enable?userId=${userId}&enabled=${enabled}`;
  }

  //* ROLE AND PERMISSIONS API'S
  getAllRoles(admin: boolean): string {
    return `${serverURL}/role/${this.getCountry()}/v1/list?admin=${admin}`;
  }

  createRoles(): string {
    return `${serverURL}/role/${this.getCountry()}/v1/create`;
  }

  savePermissions(): string {
    return `${serverURL}/role/${this.getCountry()}/v1/save`;
  }

  refreshToken(token: string): string {
    return `${serverURL}/user/${this.getCountry()}/token?token=${encodeURI(token)}`;
  }

  getAllRole() {
    return `${serverURL}/role/${this.getCountry()}/list`;
  }
  getAllPermissions() {
    return `${serverURL}/role/${this.getCountry()}/permissions`;
  }

  createRole(roleId?: string) {
    return `${serverURL}/role/${this.getCountry()}/v1/save`;
  }

  //*ADMIN-LOG
  getAllAdminLogs(params: string) {
    return `${serverURL}/admin-log/${this.getCountry()}/v1/search?${params}`;
  }

  //*DECISION-LOG
  getAllDecisionLogs(params: string) {
    return `${serverURL}/decision-log/${this.getCountry()}/v1/search?${params}`;
  }
 
  getAllRecommendationLogs(params: string) {
    return `${serverURL}/recommendation-decision-log/${this.getCountry()}/v1/search?${params}`;
  }

  //*SETTINGS
  getAllSettings() {
    return `${serverURL}/settings/${this.getCountry()}/v1/list`;
  }
  getVersionSettings(platform: string, version: string) {
    return `${serverURL}/settings/${this.getCountry()}/v1/get?platform=${platform}&version=${version}`;
  }
  saveSettings() {
    return `${serverURL}/settings/${this.getCountry()}/v1/save`;
  }

  //* ORDER

  placeOrder() {
    return `${serverURL}/order/${this.getCountry()}/v1/save`;
  }

  modifyOrder() {
    return `${serverURL}/order/${this.getCountry()}/v1/save`;
  }

  cancelOrder(orderId: string) {
    return `${serverURL}/order/${this.getCountry()}/v1/cancel?orderId=${orderId}`;
  }

  getOrderGroup(page: PaginationState) {
    return `${serverURL}/order/${this.getCountry()}/v1/group?limit=${page.limit}&page=${page.page}`;
  }

  getDashboardOrders(orderStatus: string) {
    return `${serverURL}/order/${this.getCountry()}/v1/list?orderStatus=${orderStatus}`;
  }

  getNonDashboardOrders(orderStatus: string) {
    return `${serverURL}/order/${this.getCountry()}/v1/list?orderType=nonDashboardOrders&orderStatus=${orderStatus}`;
  }

  //* WATCH-LIST
  getAllWatchLists() {
    return `${serverURL}/watch-list/${this.getCountry()}/v1/all`;
  }

  saveWatchList() {
    return `${serverURL}/watch-list/${this.getCountry()}/v1/save`;
  }

  //* USER-GROUP
  getAllUserGroups() {
    return `${serverURL}/user-group/${this.getCountry()}/v1/all`;
  }

  createNewUserGroup() {
    return `${serverURL}/user-group/${this.getCountry()}/v1/save`;
  }

  //* KITE CONNECT FOR ADMIN

  getZerodhaLoginUrlAdmin() {
    return `${serverURL}/livetick/${this.getCountry()}/v1/url`;
  }

  createZerodhaConnection() {
    return `${serverURL}/livetick/${this.getCountry()}/v1/connect`;
  }

  submitAccessTokenToServer(accessToken: string, publicToken: string) {
    return `${serverURL}/livetick/${this.getCountry()}/v1/session/create?accessToken=${accessToken}&publicToken=${publicToken}`;
  }

  getZerodhaKiteConnectStatus() {
    return `${serverURL}/livetick/${this.getCountry()}/v1/status`;
  }

  getSyncFnoAPI() {
    return `${serverURL}/livetick/${this.getCountry()}/v1/fno/sync`;
  }

  getLastFnoSyncDateAPI() {
    return `${liveTickServerUrl}/livetick/${this.getCountry()}/v1/fno/last-sync`;
  }

  disconnectKite() {
    return `${serverURL}/livetick/${this.getCountry()}/v1/disconnect`;
  }

  //* MARKET DETAILS

  getMarketQuote(stockId: string) {
    return `${serverURL}/stock/${this.getCountry()}/v1/quote?stockId=${stockId}`;
  }

  getMarketQuoteByStockGroup(stockGroupId: string) {
    return `${serverURL}/stock/${this.getCountry()}/v1/quote/stock-group?stockGroupId=${stockGroupId}`;
  }

  subscribeToWatchList(stockId?: string) {
    if (stockId) {
      return `${serverURL}/stock/${this.getCountry()}/v1/subscribe?stockId=${stockId}`;
    }
    return `${serverURL}/stock/${this.getCountry()}/v1/subscribe?stockId=`;
  }

  //*NOTIFICATIONS
  getAllNotifications() {
    return `${serverURL}/notification/${this.getCountry()}/v1/all`;
  }

  //* SECTOR LIST

  getAllSectors() {
    return `${serverURL}/sector/${this.getCountry()}/v1/list`;
  }

  saveSector() {
    return `${serverURL}/sector/${this.getCountry()}/v1/save`;
  }

  updateSector(sectorId: string) {
    return `${serverURL}/sector/${this.getCountry()}/v1/update/${sectorId}`;
  }

  deleteSector(sectorId: string) {
    return `${serverURL}/sector/${this.getCountry()}/v1/delete?sectorId=${sectorId}`;
  }

  //* FUND LIST

  getAllFund() {
    return `${serverURL}/fund/${this.getCountry()}/v1/list`;
  }

  saveFund() {
    return `${serverURL}/fund/${this.getCountry()}/v1/save`;
  }

  updateFund(fundId: string) {
    return `${serverURL}/fund/${this.getCountry()}/v1/update/${fundId}`;
  }

  deleteFund(fundId: string) {
    return `${serverURL}/fund/${this.getCountry()}/v1/delete?fundId=${fundId}`;
  }

  getUserAccount(userId: string) {
    return `${serverURL}/user/${this.getCountry()}/v1/account?userId=${userId}`;
  }

  getUserAccountByIds(accountIds: string[]) {
    return `${serverURL}/account/${this.getCountry()}/v1/list?accountIds=${accountIds}`;
  }

  saveUserAccount() {
    return `${serverURL}/user-context/${this.getCountry()}/v1/account/save`;
  }

  saveUserAccountConfig(userId: string) {
    return `${serverURL}/user-context/${this.getCountry()}/v1/account/config/save?userId=${userId}`;
  }

  getAllOrders(page: number, limit: number) {
    return `${serverURL}/order/${this.getCountry()}/v1/list?page=${page}&limit=${limit}`;
  }

  getAllOrdersByUser(userId: string) {
    return `${serverURL}/orders/${this.getCountry()}/v1/user/list?userId=${userId}`;
  }

  disableSimulation(disabled: boolean, stockId: string, simulationId: string) {
    return `${serverURL}/simulation/${this.getCountry()}/v1/stock/disable?simulationId=${simulationId}&stockId=${stockId}&disabled=${disabled}`;
  }

  getAllPendingOrders() {
    return `${serverURL}/order/${this.getCountry()}/v1/pending/list`;
  }

  getAllPendingOrdersForRecommendation() {
    return `${serverURL}/order/${this.getCountry()}/v1/pending/recommendation/list`;
  }
  approveOrderRequest(requestId: string, simulationSource: SimulationSource) {
    return `${serverURL}/order/${this.getCountry()}/v1/pending/list/approve?requestId=${requestId}&simulationSource=${simulationSource}`;
  }

  declineOrderRequest(requestId: string, orderId: string, simulationId: string, userId?: string) {
    return `${serverURL}/order/${this.getCountry()}/v1/pending/list/decline?requestId=${requestId}&orderId=${orderId}&userId=${userId}&simulationId=${simulationId}`;
  }

  getUserRecommendations(userId?: string) {
    return `${serverURL}/recommendation/${this.getCountry()}/user/list?userId=${userId}`;
  }

  getAllSimulatonRecommendations(simulationId?: string) {
    return `${serverURL}/recommendation/${this.getCountry()}/v1/simulation/list?simulationId=${simulationId}`;
  }

  clearAllOrders(simulationSource: SimulationSource) {
    return `${serverURL}/order/${this.getCountry()}/v1/pending/list/clear?simulationSource=${simulationSource}`;
  }

  saveMarketHoliday() {
    return `${serverURL}/market-holiday/${this.getCountry()}/v1/save`;
  }

  updateMarketHoliday(holidayId: string) {
    return `${serverURL}/market-holiday/${this.getCountry()}/v1/update/${holidayId}`;
  }

  deleteMarketHoliday(holidayId: string) {
    return `${serverURL}/market-holiday/${this.getCountry()}/v1/delete/${holidayId}`;
  }

  listAllMarketHolidays() {
    return `${serverURL}/market-holiday/${this.getCountry()}/v1/list`;
  }

  getOptionChain() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/get-option-chain`;
  }

  getCandle() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/get-candle`;
  }

  prepareAndStoreIndicators() {
    return `${serverURL}/simulation/${this.getCountry()}/v1/prepareAndStore`;
  }

  fetchOptionData() {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/save-option-data`;
  }

  fetchOptionOiData() {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/save-oi-data`;
  }

  getStoredDataInfoForSimulation() {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/stored-candle-details`;
  }

  getStoredDataInfoForOption(stockId: string) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/stored-option-details?stockId=${stockId}`;
  }

  getStoredDataInfoForOptionOi(stockId: string) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/stored-option-oi-details?stockId=${stockId}`;
  }

  getQueueDataForSimulation(paginationState: PaginationState) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/stored-data-info/progress/simulation?page=${paginationState.page
      }&limit=${paginationState.limit}`;
  }

  getQueueDataForOption(paginationState: PaginationState) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/stored-data-info/progress/option?page=${paginationState.page}&limit=${paginationState.limit
      }`;
  }

  getQueueDataForOptionOi(paginationState: PaginationState) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/stored-data-info/progress/option-oi?page=${paginationState.page}&limit=${paginationState.limit}`;
  }

  getSimulatedStrategyNames() {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/strategy-names`;
  }

  deleteCandleDataByStrategy(strategyName: string) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/delete/candle-data?strategyName=${encodeURIComponent(strategyName)}`;
  }

  deleteCandleData(scenario: string, stockId: string, date: string, configHash: string) {
    return `${serverURL}/historic-stock-price/${this.getCountry()}/v1/delete-candle-data?scenario=${scenario}&stockId=${stockId}&date=${date}&configHash=${configHash}`;
  }

  enableOrDisableTrade(enabled: boolean, userId: string) {
    return `${serverURL}/user-context/${this.getCountry()}/v1/admin/enable?enabled=${enabled}&userId=${userId}`;
  }

  clearUserContextById(userId: string) {
    return `${serverURL}/user-context/${this.getCountry()}/v1/clear/${userId}`;
  }

  clearUserContext() {
    return `${serverURL}/user-context/${this.getCountry()}/v1/clear`;
  }

  checkUserLoginStatus(userId: string) {
    return `${serverURL}/user/${this.getCountry()}/v1/login-status?userId=${userId}`;
  }

  getAllOrderPositions() {
    return `${serverURL}/account/${this.getCountry()}/v1/order-positions`;
  }

  createStrategy() {
    return `${serverURL}/strategy/${this.getCountry()}/v1/save`;
  }

  getStrategyById(id: string) {
    return `${serverURL}/strategy/${this.getCountry()}/v1/${id}`;
  }

  getAllStrategyUI() {
    return `${serverURL}/strategy/${this.getCountry()}/v1`;
  }

  getAllStrategyUILite() {
    return `${serverURL}/strategy/${this.getCountry()}/lite/v1`;
  }

  getAllBrokers() {
    return `${serverURL}/api/${this.getCountry()}/broker/v1/all`;
  }

  saveBroker() {
    return `${serverURL}/api/${this.getCountry()}/broker/v1/save`;
  }

  getEquities(page: PaginationState) {
    return `${serverURL}/stock/in/v1/list/equity?page=${page.page}&limit=${page.limit}`;
  }

  uploadFnoInstruments() {
    return `${serverURL}/stock/in/v1/upload-instruments/fno`;
  }
  uploadEquityInstruments() {
    return `${serverURL}/stock/in/v1/upload-instruments/equity`;
  }
  updateFnoInstruments() {
    return `${serverURL}/stock/in/v1/update-instruments/fno`;
  }
  updateEquityInstruments() {
    return `${serverURL}/stock/in/v1/update-instruments/equity`;
  }

  getFno(page: PaginationState) {
    return `${serverURL}/stock/in/v1/list/fno?page=${page.page}&limit=${page.limit}`;
  }

  searchFno(query: string, page: PaginationState, broker?: string) {
    let url = `${serverURL}/stock/in/v1/search/fno?query=${encodeURIComponent(query)}&page=${page.page}&limit=${page.limit}`;
    if (broker) url += `&broker=${encodeURIComponent(broker)}`;
    return url;
  }

  getAllAccountsBySimulation(simulationId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/live/accounts?simulationId=${simulationId}`;
  }

  getOrderByUser(accountId: string, isSimulationAccount: boolean, simulationId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/account/orders?accountId=${accountId}&isSimulationAccount=${isSimulationAccount}&simulationId=${simulationId}`;
  }

  getPositions(accountId: string, isSimulationAccount: boolean, simulationId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/account/positions?accountId=${accountId}&isSimulationAccount=${isSimulationAccount}&simulationId=${simulationId}`;
  }

  getHoldings(accountId: string, isSimulationAccount: boolean, simulationId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/account/holdings?accountId=${accountId}&isSimulationAccount=${isSimulationAccount}&simulationId=${simulationId}`;
  }

  getTransactions(accountId: string, isSimulationAccount: boolean, simulationId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/account/passbook?accountId=${accountId}&isSimulationAccount=${isSimulationAccount}&simulationId=${simulationId}`;
  }

  getAccountConfig(accountId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/account/config?accountId=${accountId}`;
  }

  changeQuantity(requestId: string, quantity: number) {
    return `${serverURL}/order/${this.getCountry()}/v1/pending/change-quantity?requestId=${requestId}&quantity=${quantity}`;
  }

  manualExecuteStrategyOrder() {
    return `${serverURL}/order/${this.getCountry()}/v1/strategy-order/manual-execute`;
  }

  editOrderPosition() {
    return `${serverURL}/order/${this.getCountry()}/v1/edit-order-position`;
  }
  getUserRecommendationMasterList(page: PaginationState, status?: string | null, userId?: string | null) {
    const params = new URLSearchParams();

    params.set('page', String(page.page));
    params.set('limit', String(page.limit));

    if (userId) {
      params.set('userId', userId);
    }

    if (status) {
      params.set('status', status);
    }

    const url = `${serverURL}/recommendation/${this.getCountry()}/v1/master/list?${params.toString()}`;
    return url;
  }

  getDeleteRequests(page: PaginationState, status?: string | null) {
    let url = `${serverURL}/admin/${this.getCountry()}/v1/delete-request?page=${page.page}&limit=${page.limit}`;
    if (status) url += `&status=${status}`;
    return url;
  }

  approveDeleteRequest() {
    return `${serverURL}/admin/${this.getCountry()}/v1/delete-request/accept`;
  }

  rejectDeleteRequest() {
    return `${serverURL}/admin/${this.getCountry()}/v1/delete-request/reject`;
  }
  getDailyTasks() {
    return `${serverURL}/checklists/${this.getCountry()}/list/today`;
  }

  completeDailyTask(taskId: string, isDone: boolean) {
    return `${serverURL}/checklists/${this.getCountry()}/complete?taskId=${taskId}&isDone=${isDone}`;
  }

  presignUpload() {
    return `${serverURL}/files/${this.getCountry()}/v1/presign-upload`;
  }

  saveMarketEvent() {
    return `${serverURL}/market-event/${this.getCountry()}`;
  }

  updateMarketEvent(eventId: string) {
    return `${serverURL}/market-event/${this.getCountry()}/${eventId}`;
  }

  deleteMarketEvent(eventId: string) {
    return `${serverURL}/market-event/${this.getCountry()}/${eventId}`;
  }

  listAllMarketEvents() {
    return `${serverURL}/market-event/${this.getCountry()}`;
  }

  checkTickServerhealth() {
    return `${liveTickServerUrl}/live-tick-server/${this.getCountry()}/health`;
  }

  getLiveTickCount() {
    return `${liveTickServerUrl}/live-tick-server/${this.getCountry()}/tick-count`;
  }

  getPortfoliioPositions(accountId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/portfolio-positions?accountId=${accountId}`;
  }
  
  getLiveTickCandle() {
    return `${liveTickServerUrl}/live-tick-server/${this.getCountry()}/candle-count`;
  }

   getUserOrderPositions(accountId: string) {
    return `${serverURL}/account/${this.getCountry()}/v1/user/order-positions?accountId=${accountId}`;
  }
}

const api = new API();
export default api;
